import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { authService } from '../services/api';

function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = authService.getCurrentUser();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth >= 768) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLogout = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      authService.logout();
      navigate('/login');
    }
  };

  const isActive = (path) => location.pathname === path;

  const navLinkStyle = (path) => ({
    padding: isMobile ? '12px 20px' : '10px 20px',
    color: isActive(path) ? 'white' : '#e0e0e0',
    textDecoration: 'none',
    borderRadius: '8px',
    background: isActive(path) ? 'rgba(255,255,255,0.2)' : 'transparent',
    fontWeight: isActive(path) ? '600' : '500',
    transition: 'all 0.3s',
    fontSize: isMobile ? '16px' : '14px',
    display: 'block',
    width: isMobile ? '100%' : 'auto',
    textAlign: isMobile ? 'left' : 'center'
  });

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <nav style={{
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: isMobile ? '12px 15px' : '15px 30px',
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
      marginBottom: '20px',
      position: 'relative'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        maxWidth: '1400px',
        margin: '0 auto'
      }}>
        {/* Logo */}
        <Link to="/dashboard" style={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          textDecoration: 'none',
          color: 'white'
        }}>
          <span style={{ fontSize: isMobile ? '28px' : '32px' }}>🏥</span>
          <div>
            <div style={{ fontSize: isMobile ? '16px' : '18px', fontWeight: 'bold' }}>Ward Stock System</div>
            {!isMobile && <div style={{ fontSize: '11px', opacity: 0.9 }}>B1 Cardiology</div>}
          </div>
        </Link>

        {/* Desktop Navigation */}
        {!isMobile && (
          <>
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              <Link to="/dashboard" style={navLinkStyle('/dashboard')}>
                📊 Dashboard
              </Link>
              
              <Link to="/products" style={navLinkStyle('/products')}>
                📦 Products
              </Link>

              {user?.role === 'staff' && (
                <>
                  <Link to="/my-orders" style={navLinkStyle('/my-orders')}>
                    🛒 My Orders
                  </Link>
                  <Link to="/request-product" style={navLinkStyle('/request-product')}>
                    ➕ Request Product
                  </Link>
                </>
              )}

              {user?.role === 'senior_nurse' && (
                <>
                  <Link to="/approve-orders" style={navLinkStyle('/approve-orders')}>
                    ✅ Approve Orders
                  </Link>
                  <Link to="/order-reports" style={navLinkStyle('/order-reports')}>
                    📊 Reports
                  </Link>
                </>
              )}

              {(user?.role === 'super_admin' || user?.role === 'super_super_admin') && (
                <>
                  <Link to="/manage-products" style={navLinkStyle('/manage-products')}>
                    ➕ Manage Products
                  </Link>
                  <Link to="/manage-product-requests" style={navLinkStyle('/manage-product-requests')}>
                    📦 Product Requests
                  </Link>
                  <Link to="/users" style={navLinkStyle('/users')}>
                    👥 Users
                  </Link>
                  <Link to="/final-orders" style={navLinkStyle('/final-orders')}>
                    📋 Final Orders
                  </Link>
                  <Link to="/order-reports" style={navLinkStyle('/order-reports')}>
                    📊 Reports
                  </Link>
                </>
              )}

              {user?.role === 'super_super_admin' && (
                <Link to="/settings" style={navLinkStyle('/settings')}>
                  ⚙️ Settings
                </Link>
              )}
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
              <div style={{
                background: 'rgba(255,255,255,0.2)',
                padding: '8px 16px',
                borderRadius: '20px',
                color: 'white',
                fontSize: '13px'
              }}>
                <div style={{ fontWeight: '600' }}>{user?.full_name}</div>
                <div style={{ fontSize: '11px', opacity: 0.9 }}>
                  {user?.role?.replace(/_/g, ' ').toUpperCase()}
                </div>
              </div>

              <button
                onClick={handleLogout}
                style={{
                  padding: '10px 20px',
                  background: 'rgba(255,255,255,0.2)',
                  color: 'white',
                  border: '2px solid rgba(255,255,255,0.3)',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontWeight: '600',
                  fontSize: '14px',
                  transition: 'all 0.3s'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'rgba(255,255,255,0.3)';
                  e.target.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'rgba(255,255,255,0.2)';
                  e.target.style.transform = 'translateY(0)';
                }}
              >
                🚪 Logout
              </button>
            </div>
          </>
        )}

        {/* Mobile Hamburger Menu */}
        {isMobile && (
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            style={{
              background: 'rgba(255,255,255,0.2)',
              border: '2px solid rgba(255,255,255,0.3)',
              color: 'white',
              padding: '10px 12px',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            {isMobileMenuOpen ? '✕' : '☰'}
          </button>
        )}
      </div>

      {/* Mobile Menu Dropdown */}
      {isMobile && isMobileMenuOpen && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
          zIndex: 1000,
          maxHeight: '80vh',
          overflowY: 'auto'
        }}>
          {/* User Info */}
          <div style={{
            padding: '15px 20px',
            background: 'rgba(255,255,255,0.1)',
            borderBottom: '1px solid rgba(255,255,255,0.2)',
            color: 'white'
          }}>
            <div style={{ fontWeight: '600', fontSize: '16px', marginBottom: '4px' }}>
              {user?.full_name}
            </div>
            <div style={{ fontSize: '13px', opacity: 0.9 }}>
              {user?.role?.replace(/_/g, ' ').toUpperCase()}
            </div>
          </div>

          {/* Navigation Links */}
          <div style={{ padding: '10px' }}>
            <Link to="/dashboard" style={navLinkStyle('/dashboard')} onClick={closeMobileMenu}>
              📊 Dashboard
            </Link>
            
            <Link to="/products" style={navLinkStyle('/products')} onClick={closeMobileMenu}>
              📦 Products
            </Link>

            {user?.role === 'staff' && (
              <>
                <Link to="/my-orders" style={navLinkStyle('/my-orders')} onClick={closeMobileMenu}>
                  🛒 My Orders
                </Link>
                <Link to="/request-product" style={navLinkStyle('/request-product')} onClick={closeMobileMenu}>
                  ➕ Request Product
                </Link>
              </>
            )}

            {user?.role === 'senior_nurse' && (
              <>
                <Link to="/approve-orders" style={navLinkStyle('/approve-orders')} onClick={closeMobileMenu}>
                  ✅ Approve Orders
                </Link>
                <Link to="/order-reports" style={navLinkStyle('/order-reports')} onClick={closeMobileMenu}>
                  📊 Reports
                </Link>
              </>
            )}

            {(user?.role === 'super_admin' || user?.role === 'super_super_admin') && (
              <>
                <Link to="/manage-products" style={navLinkStyle('/manage-products')} onClick={closeMobileMenu}>
                  ➕ Manage Products
                </Link>
                <Link to="/manage-product-requests" style={navLinkStyle('/manage-product-requests')} onClick={closeMobileMenu}>
                  📦 Product Requests
                </Link>
                <Link to="/users" style={navLinkStyle('/users')} onClick={closeMobileMenu}>
                  👥 Users
                </Link>
                <Link to="/final-orders" style={navLinkStyle('/final-orders')} onClick={closeMobileMenu}>
                  📋 Final Orders
                </Link>
                <Link to="/order-reports" style={navLinkStyle('/order-reports')} onClick={closeMobileMenu}>
                  📊 Reports
                </Link>
              </>
            )}

            {user?.role === 'super_super_admin' && (
              <Link to="/settings" style={navLinkStyle('/settings')} onClick={closeMobileMenu}>
                ⚙️ Settings
              </Link>
            )}

            {/* Logout Button */}
            <button
              onClick={() => {
                closeMobileMenu();
                handleLogout();
              }}
              style={{
                width: '100%',
                padding: '12px 20px',
                background: 'rgba(255,255,255,0.2)',
                color: 'white',
                border: '2px solid rgba(255,255,255,0.3)',
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: '600',
                fontSize: '16px',
                marginTop: '10px',
                textAlign: 'left'
              }}
            >
              🚪 Logout
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
